angular.module('elidb').filter('orderCategoryBy', function(ELIService){
	return function(categories){
		if(!categories) return categories;
		var trace = angular.trace;
		var results = [];
		var first;
		
		for(var i=0, count=categories.length; i<count; i++){
			if(categories[i].label.toLowerCase() === "masshealth"){
				first = categories[i];
			} else {
				results.push(categories[i]);
			}
		}

		function sortArray(){
			results.sort(function(a,b){
				var labelA = a.label.toUpperCase();
				var labelB = b.label.toUpperCase();
				return (labelA < labelB) ? -1 : 0;
			});
			results.unshift(first);
		}

		sortArray();
		return results;
	};
});